<template>
  <div class="container">
      <slot />
  </div>
</template>

<script>
export default {
  name: "Container",
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<style lang="less" scoped>
.container {
    padding: 0px 20px
}
</style>